import type { OrderEventListFiltersShared } from '@klear/order-event/order-event-list-filters-shared.wire'
import type { PurchaseOrderListItem } from '@klear/purchase-order/purchase-order-list.wire'
import { trpc } from '@klear/ui/lib/trpc'
import {
  isSharedOrderEventListQueryEnabled,
  type SharedOrderEventListQueryOptions
} from '@klear/ui/hooks/order-event-list-query-options'

const EMPTY_PURCHASE_ORDERS: PurchaseOrderListItem[] = []

export function usePurchaseOrders(filters?: OrderEventListFiltersShared, options?: SharedOrderEventListQueryOptions) {
  const isEnabled = isSharedOrderEventListQueryEnabled(filters, options)

  const { data, error, isLoading, refetch } = trpc.purchaseOrder.list.useQuery(filters ?? {}, { enabled: isEnabled })

  const purchaseOrders = data?.purchaseOrders ?? EMPTY_PURCHASE_ORDERS

  return { purchaseOrders, total: data?.total ?? 0, error, isLoading, refetch }
}
